/**
 * =============================================================================
 *  `?symbol=` 的解析 —— 一個只在台股發作的 bug。
 *
 *  TanStack Router 的預設 search 解析器是 `JSON.parse`。於是：
 *
 *    /tw/dashboard?symbol=2317   →  JSON.parse('2317')  →  **number** 2317
 *    /tw/dashboard?symbol="2317" →  JSON.parse('"2317"') →  string '2317'
 *    /us/dashboard?symbol=NVDA   →  JSON.parse 丟出      →  string 'NVDA'
 *
 *  router 自己導覽時寫出來的是第二種（它偵測到字串會 round-trip 成數字，
 *  所以幫你加引號）。但**人手打的、貼在 LINE 群組裡的、寫在文件裡的**
 *  是第一種——也就是 ROADMAP §5 Demo 逐字寫的那個 `?symbol=2330`。
 *
 *  只認字串的話，那個連結會安靜地退回「上次看的那一檔」：畫面完全正常、
 *  網址列還留著 2317、但畫的是 2330。使用者不會回報這件事，他只會覺得怪。
 *
 *  美股代號不受影響（字母開頭，`JSON.parse` 直接丟），所以這個 bug 只打台股，
 *  也就是這個產品絕大多數的分享連結。
 * ========================================================================== */

/** `0050` 經過 `JSON.parse` 會變成 50；台股代號補回四位。 */
export function parseSymbolParam(raw: unknown): string | undefined {
  if (typeof raw === 'number' && Number.isFinite(raw)) {
    const digits = String(Math.trunc(Math.abs(raw)));
    // 五位數以上（興櫃、權證、ETN）維持原樣，不要硬補成四位。
    return digits.length < 4 ? digits.padStart(4, '0') : digits;
  }
  if (typeof raw !== 'string') return undefined;
  const trimmed = raw.trim();
  return trimmed === '' ? undefined : trimmed.toUpperCase();
}
